import React from "react";
import {hashHistory} from 'react-router';
import {GoogleMapLoader, GoogleMap, InfoWindow, Marker, KmlLayer} from "react-google-maps";
import {observer, inject} from 'mobx-react';
import MapMarkerLegends from './MapMarkerLegends';
import {proxyUrl} from '../../libs/config';
import {Paper} from 'material-ui';
import {observable} from "mobx";

@inject('markerStore')
@observer
class MapPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      station: {},
      data_series: [],
      curMar: {},
      markersData: []
    };
  }

  @observable selectedMarker = null;

  handleMarkerClick(marker) {
    this.setState({curMar: Object.assign({}, marker)});
    this.selectedMarker = marker;
    marker.showInfo = true;
    this.setState(this.state);
  }

  handleMarkerClose(marker) {
    // this.selectedMarker = null;
    marker.showInfo = false;
    this.setState(this.state);
  }

  renderInfoWindow(ref, marker) {
    let title = `${marker.name} ${marker.stationIndex ? `(${marker.stationIndex})` : ''}`;
    return (
      <InfoWindow key={`${ref}_info_window`} onCloseclick={this.handleMarkerClose.bind(this, marker)}>
        <div>
          <a><h4 className="primart_text_color" onClick={() => this.onMarkerClick(marker, true)}>{title}</h4></a>
          {marker.waterlevel &&
          <div>
            <b>{marker.waterlevel && marker.waterlevel.data.value}</b>
            <p>{marker.waterlevel && marker.waterlevel.data.datetime}</p>
          </div>}
          {marker.rainfall &&
          <table className="table">
            <caption>Accumulated Rainfall</caption>
            <tbody>{
              marker.rainfall.averages.map((item, i) => (
                <tr key={i}>
                  <td>{`${item.interval} hours`}</td>
                  <td>{item.value === 'N/A' ? '-' : `${item.value} mm`}</td>
                </tr>
              ))
            }</tbody>
          </table>}
        </div>
      </InfoWindow>
    );
  }

  renderCustomInfoWindow() {
    let marker = this.selectedMarker;
    let title = `${marker.name} ${marker.stationIndex ? `(${marker.stationIndex})` : ''}`;

    return (
      <Paper className="info-window">
        <div>
          <a><p className="primart_text_color" style={{fontSize: '20px'}}
                onClick={() => this.onMarkerClick(marker, true)}>{title}</p></a>
          {marker.district && <p style={{fontStyle:'italic'}}>{marker.district}</p>}
          <span className="info-window-close glyphicon glyphicon-remove" onClick={() => this.selectedMarker = null}/>
        </div>
        <div style={{padding: '5px'}}>
          {marker.waterlevel &&
          <div>
            <b>{marker.waterlevel && marker.waterlevel.data.value}</b>
            <p>{marker.waterlevel && marker.waterlevel.data.datetime}</p>
          </div>}
          {marker.rainfall &&
          <table className="table" style={{marginBottom: '0px'}}>
            <caption>Accumulated Rainfall</caption>
            <tbody>{
              marker.rainfall.averages && marker.rainfall.averages.map((item, i) => (
                <tr key={i}>
                  <td>{`${item.interval} hours`}</td>
                  <td>{item.value === null ? '-' : `${item.value} mm`}</td>
                </tr>
              ))
            }</tbody>
          </table>}
        </div>
      </Paper>
    );
  }

  onMarkerClick = (marker, fromTitle) => {
    if (this.props.mobView) {
      fromTitle && hashHistory.push(`/basin/${marker.id}`);
    } else {
      hashHistory.push(`/basin/${marker.id}`);
    }
  };

  getFilteredMarkers = (markers) => {
    const {filteredStations} = this.props;
    const filteredMarker = [];
    if (!filteredStations) {
      return markers;
    } else {
      // eslint-disable-next-line array-callback-return
      markers.map(marker => {
        if (filteredStations.filter(s => +s.id === +marker.id)[0]) {
          filteredMarker.push(marker);
        }
      });
      return filteredMarker;
    }
  };

  render() {
    const {markerStore} = this.props;

    // console.log(markerStore.getCombinedMarkers)
    /* eslint-disable no-undef */
    return (
      <Paper zDepth={1} className='map-page' style={this.props.style}>
        <GoogleMapLoader
          containerElement={<div {...this.props} style={{
            top: '0px',
            height: this.props.mobView?'350px':'500px',
            width: '100%',
            position: 'relative',
            marginBottom: '5px'
          }}/>}
          googleMapElement={
            <GoogleMap defaultCenter={{lat: 28.082787, lng: 84.499982}} defaultZoom={7} ref="map"
                       options={{minZoom: 7}}>
              {this.selectedMarker ? this.renderCustomInfoWindow() : null}
              <KmlLayer url={`${proxyUrl}/overlays/watershed_wgs.kml`} options={{preserveViewport: true}}>
                {this.getFilteredMarkers(markerStore.getCombinedMarkers).map((marker, index) => {
                  const ref = `marker_${index}`;
                  return (
                    <Marker icon={{url:marker.icon}}
                            key={index} ref={ref} position={marker.position}
                            onClick={() => this.onMarkerClick(marker)}
                            onMouseover={() => this.handleMarkerClick(marker, false)}>
                      {/*{marker.showInfo && marker.name === this.state.curMar.name ? this.renderInfoWindow(ref, marker) : null}*/}
                    </Marker>
                  );
                })
                }
              </KmlLayer>
            </GoogleMap>}
        />
        <MapMarkerLegends/>
      </Paper>

    );
  }
}

export default MapPage;






// WEBPACK FOOTER //
// ./src/components/Home/MapPage.js